<div class="race-time-status">
    @if (race.addons.raceSummary) {
        <span [ngClass]="race.addons.raceSummary.length > maxChars ? 'status-text status-font-resize' : 'status-text'">
            {{ updateStatus(race) }}
        </span>
    } @else {
        @if (display) {
            <span [ngClass]="{ 'startingin-disabled': isHomeRaceTime, 'race-starts-in-text': isSports }"
                >{{ sitecore.horseRacing.nextThreeRaces!.StartingIn }}
            </span>
        }
        <ms-countdown-timer
            [timeInSeconds]="timeInSeconds"
            [textAfterTimerFinished]="textAfterTimerFinished"
            [isSports]="isSports"
            (display)="onDisplay($event)" />
    }
</div>
